// Action Types
export const UPDATE_VAS_CONTROL_DATA_REQUEST = "UPDATE_VAS_CONTROL_DATA_REQUEST";
export const UPDATE_VAS_CONTROL_DATA_SUCCESS = "UPDATE_VAS_CONTROL_DATA_SUCCESS";
export const UPDATE_VAS_CONTROL_DATA_FAILURE = "UPDATE_VAS_CONTROL_DATA_FAILURE";
export const UPDATE_VAS_CONTROL_DATA_RESET = "UPDATE_VAS_CONTROL_DATA_RESET";
// Action Creators
export const updateVasControlDataRequest = (payload) => ({
    type: UPDATE_VAS_CONTROL_DATA_REQUEST,
    payload,
});
export const updateVasControlDataSuccess = (payload) => ({
    type: UPDATE_VAS_CONTROL_DATA_SUCCESS,
    payload,
});
export const updateVasControlDataFailure = (payload) => ({
    type: UPDATE_VAS_CONTROL_DATA_FAILURE,
    payload,
});
export const updateVasControlDataReset = () => ({
    type: UPDATE_VAS_CONTROL_DATA_RESET,
});
